<template>
  <v-row justify="center">
    <v-col cols="12" style="max-width:680px">
      <v-sheet class="pt-12 text-left">
        <Markdown class="caslon--font title mb-10" :source="welcomePage" />
        <div class="text-center" v-if="$route.query.email && $route.query.jwt">
          <v-btn
            color="blue darken-1"
            depressed
            x-large
            class="mx-auto white--text"
            :to="{ path: '/activate', query: $route.query }"
            >Continue to Activate</v-btn
          >
        </div>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import Markdown from '@/components/Markdown'

export default {
  name: 'WelcomeView',
  components: { Markdown },
  computed: {
    ...mapGetters('shop', ['getShopDetail']),
    welcomePage() {
      return this.getShopDetail('Welcome Page')
    },
  },
  data() {
    return {}
  },
}
</script>
